import { BrowserRouter as Router } from "react-router-dom"
import { ToastContainer, toast } from 'react-toastify';
import { getUtilityStateSelector } from './redux/selectors/utilitySelector';
import AppRoutes from './routes';
import './assets/styles/main.scss';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from 'react-redux';
import { setAzureLogin, initLogin } from './redux/login/loginSlice';

function App() {
  const utilityState = getUtilityStateSelector();
  const { showToast } = utilityState;
  const { instance } = useMsal();
  const dispatch = useDispatch();
  
  useEffect(() => {
    const init = async () => {
      try {
        // Wait for MSAL to fully initialize
        await instance.initialize();

        // Handle redirect responses
        const response = await instance.handleRedirectPromise();
        
        if (response) {
          
          // User returned from redirect authentication
          if (response.account) {
            
            // Try to get access token
            try {
              const tokenResponse = await instance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: response.account,
              });
              
              if (tokenResponse.accessToken) {
                dispatch(setAzureLogin(true));
                dispatch(initLogin({ token: tokenResponse.accessToken }));
              }
                          } catch (tokenError) {
                // Handle token error silently
              }
                      }
        }
        

              } catch (error) {
          // Handle initialization error silently
        }
    };

    init();
  }, [instance, dispatch]);

  useEffect(() => {
    if (showToast?.type === 'success') {
      toast.success(showToast?.message)
    } else if (showToast?.type === 'fail') {
      toast.error(showToast?.message)
    }
  }, [showToast])

  return (
    <>
      <Router>
        <ToastContainer />
        <AppRoutes />
      </Router>
    </>
  );
}

export default App;
